/**
 * Copyright (c) 2021 BlockDev AG
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

export const PATHS = {
    home: '/',
    login: '/login',
    dashboard: '/dashboard',
    transactionComplete: '/transaction/complete',
    styleGuide: '/style-guide',
};
